import { PRODUCT_TYPE } from '../define/global';

export const isProducType_WITH_URL_OPENER_B2B = (type) => type === PRODUCT_TYPE.WITH_URL_OPENER_B2B;
export const isProducType_STANDALONE = (type) => type === PRODUCT_TYPE.STANDALONE;
export const isProducType_WITH_PO_SERVICE = (type) => type === PRODUCT_TYPE.WITH_PO_SERVICE;
export const isProducType_WITH_GOOGLE_DRIVE = (type) => type === PRODUCT_TYPE.WITH_GOOGLE_DRIVE;
